/* ============================================================
   555 SHOP — Cinematic motion (GSAP, progressive enhancement)
   - Hero: masked title reveal, meta/body/CTA stagger, Ken-Burns,
     parallax, magnetic CTA.
   - Jersey reveal: flocage draws in on vertical scroll (scrub).
   Graceful fallback without GSAP / reduced-motion / theme editor.
   Section reveals are handled by reveal.js.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var gsap   = window.gsap;
    var ST     = window.ScrollTrigger;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = document.documentElement.classList.contains('shopify-design-mode');
    var animate = !!gsap && !reduce && !design;

    if (gsap && ST) gsap.registerPlugin(ST);

    /* ---------- HERO ---------- */
    var hero = document.querySelector('[data-hero]');
    if (hero) {
      /* Smooth-scroll for CTA + scroll cue (always) */
      function smooth(sel) {
        var t = document.querySelector(sel);
        if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
      var ctaEl = hero.querySelector('[data-hero-cta]');
      if (ctaEl) ctaEl.addEventListener('click', function (e) {
        var h = ctaEl.getAttribute('href');
        if (h && h.charAt(0) === '#') { e.preventDefault(); smooth(h); history.replaceState(null, '', h); }
      });
      var cue = hero.querySelector('[data-hero-scroll]');
      if (cue) cue.addEventListener('click', function () { smooth('#configurator'); });

      if (!animate) {
        hero.classList.add('is-ready', 'is-in');
      } else {
        var MASK = 'cubic-bezier(0.77,0,0.175,1)';
        hero.classList.add('is-ready');

        var lines = hero.querySelectorAll('.hero-555__line > span');
        var meta  = hero.querySelector('[data-hero-meta]');
        var body  = hero.querySelector('.hero-555__body');
        var cta   = hero.querySelector('.hero-555__cta');
        var img   = hero.querySelector('.hero-555__img');

        gsap.set(lines, { yPercent: 110 });
        var tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
        if (meta) tl.from(meta, { y: -12, autoAlpha: 0, duration: 0.6 }, 0.1);
        tl.to(lines, { yPercent: 0, duration: 1.1, ease: MASK, stagger: 0.09 }, 0.2);
        if (body) tl.from(body, { y: 16, autoAlpha: 0, duration: 0.6 }, 0.75);
        if (cta)  tl.from(cta,  { y: 16, autoAlpha: 0, duration: 0.5 }, 0.95);

        if (img) {
          gsap.to(img, { scale: 1.07, duration: 60, ease: 'none', repeat: -1, yoyo: true });
          if (ST) gsap.to(img, { yPercent: 8, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        }
        if (ST) gsap.to(hero.querySelector('.hero-555__inner'), { yPercent: 12, autoAlpha: 0.85, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });

        if (window.matchMedia('(pointer:fine)').matches) {
          var mag = document.querySelectorAll('[data-magnetic]');
          for (var i = 0; i < mag.length; i++) {
            (function (el) {
              var s = 0.3;
              el.addEventListener('mousemove', function (e) {
                var r = el.getBoundingClientRect();
                gsap.to(el, { x: (e.clientX - r.left - r.width / 2) * s, y: (e.clientY - r.top - r.height / 2) * s, duration: 0.6, ease: 'power4.out' });
              });
              el.addEventListener('mouseleave', function () { gsap.to(el, { x: 0, y: 0, duration: 0.8, ease: 'back.out(1.4)' }); });
            })(mag[i]);
          }
        }
      }
    }

    /* ---------- JERSEY: vierge -> floqué (scroll-driven) ---------- */
    var jr = document.querySelector('[data-jersey-reveal]');
    if (jr && animate && ST) {
      var flocs = jr.querySelectorAll('[data-floc]');
      gsap.set(flocs, { autoAlpha: 0, y: 18, scale: 0.9 });
      gsap.to(flocs, {
        autoAlpha: 1, y: 0, scale: 1,
        ease: 'power3.out',
        stagger: 0.18,
        scrollTrigger: { trigger: jr, start: 'top 78%', end: 'center 58%', scrub: 1 }
      });
      /* base jersey subtle lift as you scroll through */
      gsap.utils.toArray(jr.querySelectorAll('.jr-555__jersey')).forEach(function (el) {
        gsap.fromTo(el, { yPercent: 4 }, { yPercent: -4, ease: 'none', scrollTrigger: { trigger: jr, start: 'top bottom', end: 'bottom top', scrub: true } });
      });
    }
  });
})();
